import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from '@mui/material';

interface FileInfo {
  filename: string;
  status: string;
}

interface FilenameTableProps {
  eno1FileInfos: FileInfo[];
  e55FileInfos: FileInfo[];
  e09FileInfos: FileInfo[];
  direction: 'inbound' | 'outbound';
}

function FilenameTable({ eno1FileInfos, e55FileInfos, e09FileInfos, direction }: FilenameTableProps) {
  // Don't render the table if there are no files
  if (
    (!eno1FileInfos || eno1FileInfos.length === 0) &&
    (!e55FileInfos || e55FileInfos.length === 0) &&
    (!e09FileInfos || e09FileInfos.length === 0)
  ) {
    return null;
  }

  // Get the maximum length to determine table rows
  const maxFiles = Math.max(
    eno1FileInfos?.length || 0,
    e55FileInfos?.length || 0,
    e09FileInfos?.length || 0
  );

  return (
    <Box sx={{ mb: 4 }} data-testid={`filename-table-container-${direction}`}>
      <Typography variant="h6" sx={{ mb: 2, color: '#063142', fontWeight: 600 }} data-testid={`filename-table-title-${direction}`}>
        File Names - {direction.charAt(0).toUpperCase() + direction.slice(1)}
      </Typography>
      
      <TableContainer component={Paper} sx={{ maxWidth: '100%' }} data-testid={`filename-table-container-paper-${direction}`}>
        <Table size="small" data-testid={`filename-table-${direction}`}>
          <TableHead data-testid={`filename-table-head-${direction}`}>
            <TableRow sx={{ backgroundColor: '#E7EFF5' }} data-testid={`filename-table-header-row-${direction}`}>
              <TableCell sx={{ fontWeight: 600, color: '#063142' }} data-testid={`filename-table-eno1-header-${direction}`}>eNO1 File</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#063142' }} data-testid={`filename-table-eno1-status-header-${direction}`}>eNO1 Status</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#063142' }} data-testid={`filename-table-e55-header-${direction}`}>e55 File</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#063142' }} data-testid={`filename-table-e55-status-header-${direction}`}>e55 Status</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#063142' }} data-testid={`filename-table-e09-header-${direction}`}>e09 File</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#063142' }} data-testid={`filename-table-e09-status-header-${direction}`}>e09 Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody data-testid={`filename-table-body-${direction}`}>
            {Array.from({ length: maxFiles }, (_, index) => (
              <TableRow key={index} hover data-testid={`filename-table-row-${direction}-${index}`}>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }} data-testid={`filename-table-eno1-cell-${direction}-${index}`}>
                  {eno1FileInfos?.[index]?.filename || '-'}
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }} data-testid={`filename-table-eno1-status-cell-${direction}-${index}`}>
                  {eno1FileInfos?.[index]?.status || '-'}
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }} data-testid={`filename-table-e55-cell-${direction}-${index}`}>
                  {e55FileInfos?.[index]?.filename || '-'}
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }} data-testid={`filename-table-e55-status-cell-${direction}-${index}`}>
                  {e55FileInfos?.[index]?.status || '-'}
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }} data-testid={`filename-table-e09-cell-${direction}-${index}`}>
                  {e09FileInfos?.[index]?.filename || '-'}
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }} data-testid={`filename-table-e09-status-cell-${direction}-${index}`}>
                  {e09FileInfos?.[index]?.status || '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default FilenameTable;
